export const Data = {};

export const DigiData = {};

export const DataPanUdyam = {};

export const Data2 = {};

export const Data3 = {};

export const Data4 = {};

export const AadharData = {};

export const Data6 = {};

export const Data7 = {};

export const Data8 = {};

export const aadharVerifyData = {};

export const cinData = {};

export const itrComplinceData = {};

export const rationCardData = {};

export const Bankstatement = {};

export const sendOpt = {};

export const EV2MobileVerify = {};
